require('../css/reset.css');
require('../css/tgs.css');
require('../css/video.css');
require('../css/slider.css');


require('../js/compontents/animate.js');
require('../js/plugins/biliSlider.js');
require('../js/plugins/biliPager.js');
require('../js/compontents/slider.js');
require('../js/compontents/tgs.js');





/** WEBPACK FOOTER **
 ** ./src/js/main.js
 **/